// @flow

import React, { type Node, useCallback } from 'react';
import { usePayment } from '../context';
import { CheckmarkSvg } from '../../pix-jsr-enrollment/screens/success-screen';
import {
  Container,
  Content,
  CheckmarkIcon,
  Title,
  Subtitle,
  ReturnButton,
} from './success-screen.styles';

const ALLOWED_SCHEMES = ['https:', 'http:'];

function isSafeUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ALLOWED_SCHEMES.includes(parsed.protocol);
  } catch {
    return false;
  }
}

export function SuccessScreen(): Node {
  const { data } = usePayment();
  const hasRedirect = data.redirectUrlAfterPayment && isSafeUrl(data.redirectUrlAfterPayment);

  const handleReturnToStore = useCallback(() => {
    if (hasRedirect) {
      window.location.href = data.redirectUrlAfterPayment;
    }
  }, [hasRedirect, data.redirectUrlAfterPayment]);

  return (
    <Container>
      <Content>
        <CheckmarkIcon>
          <CheckmarkSvg />
        </CheckmarkIcon>

        <Title>Pagamento realizado com sucesso!</Title>
        {hasRedirect ? (
          <Subtitle>
            Volte à loja para acompanhar sua compra.
          </Subtitle>
        ) : null}

        {hasRedirect ? (
          <ReturnButton onClick={handleReturnToStore}>
            Voltar à loja
          </ReturnButton>
        ) : null}
      </Content>
    </Container>
  );
}
